import PasswordSection from "../components/account/PasswordSection";
import ProfileSection from "../components/account/ProfileSection";
import React from "react";
import { Box, Typography } from "@mui/material";
import { useAccountSettings } from "../hooks/useAccountSettings";

export default function AccountSettings() {
  const { formData, formErrors, isSaving, handleChange, handleSaveProfile, handleChangePassword } =
    useAccountSettings();

  return (
    <Box sx={{ p: { xs: 2, sm: 3 } }}>
      <Typography variant="h5" fontWeight={600} sx={{ mb: 2, color: "#2f2f2f" }}>
        Ustawienia konta
      </Typography>

      <ProfileSection
        formData={formData}
        formErrors={formErrors}
        isSaving={isSaving}
        onChange={handleChange}
        onSave={handleSaveProfile}
      />

      <PasswordSection
        formData={formData}
        formErrors={formErrors}
        isSaving={isSaving}
        onChange={handleChange}
        onChangePassword={handleChangePassword}
      />
    </Box>
  );
}
